module.exports = __webpack_public_path__ + "static/media/icon_free_a.839c76c7.svg";